import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { CardBrandIcon } from '~/components/common/CardBrandIcon'
import { MarketingButton } from '~/components/common/MarketingButton'
import React from 'react'
import { Card } from '~/lib/types/AdvAccount'

type CardActionConfirmProps = {
  card: Card
  open: boolean
  onClose: (status: boolean) => void
  onOk: (cardId: string) => Promise<void>
  actionText: string
}
export const CardActionConfirmDialog = ({ card, open, onClose, onOk, actionText }: CardActionConfirmProps) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{actionText}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          選択された以下のカードについて{actionText}を実行しますがよろしいでしょうか？
          <br />
          番号下４桁： {card.last4}
          <br />
          有効期限(月/年)： {card.expMonth}/{card.expYear}
          <br />
          種別：
          <CardBrandIcon brand={card.brand} size={20} />
          <br />
          <br />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MarketingButton onClick={() => onOk(card.id)} variant="contained">
          はい
        </MarketingButton>
        <MarketingButton
          onClick={() => {
            onClose(false)
          }}
          variant="outlined"
        >
          いいえ
        </MarketingButton>
      </DialogActions>
    </Dialog>
  )
}
